var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"signalReturn"}},[_vm._v("碎片信号回流分析")])
}
var staticRenderFns = []

export { render, staticRenderFns }